import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { Child } from '@/types/child';

type CreateChildRequest = {
  contract_start_date: string;
  contract_end_date?: string;
  last_name: string;
  first_name: string;
  last_name_kana: string;
  first_name_kana: string;
  guardian_id: number;
  guardian_relation_ship:
    | 'father'
    | 'mother'
    | 'grandfather'
    | 'grandmother'
    | 'uncle'
    | 'aunt'
    | 'other';
  email: string;
  phone_number: string;
  notes?: string;
  office_ids: number[];
};

export const createChild = async (input: CreateChildRequest): Promise<ApiResult<Child>> => {
  const { status, result } = await callApi<Child>(
    `children`,
    'POST',
    undefined,
    input,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
